import styled from '@emotion/styled'
import { Terms } from 'main/components/common/AuthModal/common'
import { breakpoints, Button, palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > :not(:last-child) {
    padding-top: ${spacing.majorScale(1)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    justify-content: space-between;
    padding: ${spacing.majorScale(1)}px 0;

    > :not(:last-child) {
      padding-top: 0;
      margin-right: ${spacing.majorScale(1)}px;
    }
  }
`

export const StyledButton = styled(Button)`
  margin-top: ${spacing.majorScale(1)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: inherit;
  }
`

export const StyledTerms = styled(Terms)`
  margin-top: ${spacing.majorScale(1)}px;
`

export const TitleText = styled(Text)`
  color: ${palette.slate};
  margin: ${spacing.majorScale(1)}px 0;
`
